import { graphql } from '../../graphql';

export const getCategories = graphql(`
  query Categories {
    categories {
      ...CategoryFields
    }
  }
`);
